import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { GENERAL_PAGE_PATH } from "utils/constants/paths";

const GeneralPage = Loadable(React.lazy(() => import("./View")));

export const GeneralPageRoute: IRouteItem = {
  path: GENERAL_PAGE_PATH,
  element: React.createElement(GeneralPage),
  name: "General",
};
